import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { API_BASE_URL } from "../../core/base.service";
import type { ShareScorePayload } from "../utils/score-share";

/** 后端 Create 返回：短 token + 过期时间 */
export interface ScoreShareCreateResponse {
  token: string;
  /** ISO 日期字符串，前端展示用 */
  expireTime: string;
}

/** 后端 Get 返回：按 status 区分三种状态 */
export type ScoreShareGetResponse =
  | { status: "ok"; data: ShareScorePayload; expireTime: string }
  | { status: "expired"; expireTime: string }
  | { status: "invalid" };

/**
 * 成绩分享短链接服务
 *
 * - create：老师生成成绩分享二维码时，把成绩单 JSON 存库并拿到短 token（需登录）
 * - get：家长扫码后用 token 取回成绩单（公开，7 天有效）
 */
@Injectable({ providedIn: "root" })
export class ScoreShareService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL, { optional: true }) || "";

  /** 生成成绩分享短链接（需登录），返回 token + 过期时间 */
  create(payload: ShareScorePayload): Observable<ScoreShareCreateResponse> {
    return this.http.post<ScoreShareCreateResponse>(
      `${this.apiBaseUrl}/scoreShare/Create`,
      payload,
    );
  }

  /** 按 token 获取成绩分享数据（公开，7 天有效） */
  get(token: string): Observable<ScoreShareGetResponse> {
    return this.http.get<ScoreShareGetResponse>(
      `${this.apiBaseUrl}/scoreShare/Get`,
      { params: { token } },
    );
  }
}
